import React from 'react';

const Introduction = () => {
  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-2">I'm Ray! Nice to meet you 👋</h1>
      <p className="text-xl text-gray-300 mb-1">
        Computer Science Graduate from Columbia University
      </p>
      <p className="text-xl text-gray-300">
        Full Stack & AI Software Developer
      </p>
    </div>
  );
};

export default Introduction;